import { ReactNode } from "react";
import {
  Container,
  Content,
  Description,
  InputWrapper,
} from "./__styles__/ComplexRadio";

interface Props<Value> {
  checked: boolean;
  onChange: (value: Value) => void;
  value: Value;
  label: string | ReactNode;
  children: ReactNode;
  name: string;
  description?: Maybe<string>;
  disabled?: boolean;
}

export default <Value extends string | number>({
  checked,
  onChange,
  label,
  children,
  value,
  description,
  name,
  disabled,
}: Props<Value>) => {
  return (
    <Container>
      <InputWrapper>
        <input
          type="radio"
          name={name}
          value={value}
          checked={checked}
          onChange={event => {
            onChange(event.target.value as Value);
          }}
          disabled={disabled}
        />
        <div>
          <div>{label}</div>
          <Description>{description}</Description>
        </div>
      </InputWrapper>
      <Content>{children}</Content>
    </Container>
  );
};
